import { render, staticRenderFns } from "./DownloadInvalidationJson.vue?vue&type=template&id=83bb2e34"
import script from "./DownloadInvalidationJson.vue?vue&type=script&lang=js"
export * from "./DownloadInvalidationJson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports